import { useMemo } from 'react';
import { DefaultTheme, useTheme } from 'styled-components';

import { Message, MessageOptions } from '@dreryk/react-components';

import { generalSettingsTranslationKeys } from '../../../../../translations';

export type PreInterviewTemplateStatus = 'PUBLISHED' | 'EDIT' | 'NOT_PUBLISHED';

const createPreInterviewTemplateStatusOptions = (
   theme: DefaultTheme
): MessageOptions<Record<PreInterviewTemplateStatus, string>> => ({
   PUBLISHED: {
      color: theme.success,
      backgroundColor: theme.successLighter,
   },
   NOT_PUBLISHED: {
      color: theme.error,
      backgroundColor: theme.errorLighter,
   },
   EDIT: {
      color: theme.warning,
      backgroundColor: theme.warningLighter,
   },
});

const useOptions = (): MessageOptions<Record<PreInterviewTemplateStatus, string>> => {
   const theme = useTheme();
   return useMemo(() => createPreInterviewTemplateStatusOptions(theme), [theme]);
};

type SurveyPreInterviewTemplateStatusProps = {
   readonly preInterviewTemplateStatus: keyof Record<PreInterviewTemplateStatus, string>;
};

export const SurveyPreInterviewTemplateStatus = (props: SurveyPreInterviewTemplateStatusProps): JSX.Element => {
   return (
      <Message
         displayIndicator
         options={useOptions()}
         testId={'preInterviewTemplateStatus'}
         type={props.preInterviewTemplateStatus}
         label={generalSettingsTranslationKeys.survey.preInterview.templateStatus[props.preInterviewTemplateStatus]}
      />
   );
};
